import {
    Typography,
    Grid,
    useTheme,
    Box,
    useMediaQuery
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';


import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import Contacts from '../HomePage/contacts';
import { alert_outlined, alert_outlined_white, goal, heart_outlined, heart_outlined_white, smile_outlined, star_outlined, vision } from '../../../assets/icons';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import TeamCarousel from './team';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



const AboutUs = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Про нас", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Про нас`;

    }, [])

    return (
        <>
            <HideForms />
            <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ mt: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "43px", lg: "120px" } }}>
                <Grid item xs={4} md={5} lg={12} >
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "28px", lg: "20px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" sx={{ fontSize: { xs: "26px", md: "h3.fontSize", lg: "h2.fontSize" } }}>
                        Про нас
                    </Typography>
                    <Typography variant="h5" fontFamily="Fixel Display, sans-serif" sx={{ mt: { xs: "14px", lg: "20px" } }}>
                        Про тебе і Україну — це громадська організація, заснована в листопаді 2022 року, яка працює над розвитком демократичного суспільства через популяризацію та збереження української культури. Ми реалізуємо свою діяльність у понад п’яти областях України, залучаючи молодь до неформальної освіти, культурно-просвітницьких заходів і творчих ініціатив. Наші інтерактивні проєкти поєднують історичний контекст із сучасними мультимедійними форматами, що допомагає глибше зрозуміти суспільні процеси та їхній вплив на сьогодення.
                        <br />
                        <br />
                        Завдяки співпраці з музеями, істориками та науковими установами ми забезпечуємо високий рівень змістовності та наукової точності наших проєктів. Учасники заходів мають можливість не лише розширити знання про історію, а й усвідомити значення культури як інструменту об’єднання суспільства та збереження національної ідентичності.
                    </Typography>
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: { xs: "43px", lg: "75px" } }}>
                    <Box sx={{ width: { xs: "362px", md: "364px", lg: "580px" }, height: { xs: "225px", md: "196px", lg: "230px" }, background: palette.text.secondary, borderRadius: "15px", p: { xs: "30px", md: "20px", lg: "30px" } }}>
                        <Box sx={{ display: "flex" }}>
                            <img
                                loading="eager" src={goal} alt="goal" style={{ width: "32px", height: "32px", marginRight: "12px" }} />
                            <Typography variant='h3' fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ md: "18px", lg: "22px" }} lineHeight="34px" color={palette.background.default}>
                                Місія
                            </Typography>
                        </Box>
                        <Typography variant='h5' fontFamily="Fixel Display, sans-serif" fontWeight="600" color={palette.background.default} sx={{ mt: "12px" }}>
                            Сприяти залученню молоді до пізнання та розвитку української культури, демонструючи її ключову роль у формуванні демократичного суспільства.
                        </Typography>
                    </Box>
                    <Box sx={{ width: { xs: "362px", md: "364px", lg: "710px" }, height: { xs: "225px", md: "196px", lg: "230px" }, background: palette.primary.dark, borderRadius: "15px", p: { xs: "30px", md: "20px", lg: "30px" }, mt: { xs: "14px", md: "0px" } }}>
                        <Box sx={{ display: "flex" }}>
                            <img
                                loading="eager" src={vision} alt="vision" style={{ width: "32px", height: "32px", marginRight: "12px" }} />
                            <Typography variant='h3' fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ md: "18px", lg: "22px" }} lineHeight="34px">
                                Візія
                            </Typography>
                        </Box>
                        <Typography variant='h5' fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: "12px" }}>
                            Свідоме українське суспільство, в якому кожен розуміє значення культурної та історичної спадщини, активно зберігає й передає їх майбутнім поколінням.
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "50px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" sx={{ fontSize: { xs: "h3.fontSize", lg: "h2.fontSize" } }}>
                        Цінності
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: "12px" }}>
                        <Box
                            sx={{
                                width: { xs: "365px", lg: "337px" },
                                height: { xs: "250px", lg: "282px" },
                                background: palette.text.secondary,
                                borderRadius: "8px",
                                p: { xs: "7px 11px", lg: "7px 11px 11px 11px" }
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    loading="eager" src={star_outlined} alt="star_outlined" style={{ width: "40px", height: "40px", marginRight: "20px" }} />
                                <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={palette.background.default}>
                                    Прозорість і відкритість
                                </Typography>
                            </Box>
                            <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={palette.background.default} sx={{ mt: { xs: "6px", lg: "20px" } }}>
                                Ми дотримуємося принципів чесності, прозорості та відкритого діалогу з громадою. Наша діяльність побудована на довірі, партнерстві та взаємоповазі.
                                <br /><br />
                                Ми завжди готові слухати, підтримувати ініціативи та враховувати різноманітні точки зору.
                            </Typography>
                        </Box>
                        <Box sx={{
                            width: { xs: "365px", lg: "300px" },
                            height: { xs: "250px", lg: "282px" },
                            background: palette.primary.dark,
                            borderRadius: "8px",
                            mt: { xs: "14px", md: "0px" },
                            p: "7px 11px 11px 11px"
                        }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    loading="eager" src={smile_outlined} alt="smile_outlined" style={{ width: "40px", height: "40px", marginRight: "20px" }} />
                                <Typography variant='h5' fontFamily="Fixel Display, sans-serif">
                                    Фаховість і надійність
                                </Typography>
                            </Box>
                            <Typography variant='h5' fontFamily="Fixel Display, sans-serif" sx={{ mt: { xs: "6px", lg: "20px" } }}>
                                Ми прагнемо до професійного підходу у всьому, що робимо. Висока якість роботи, відповідальність та дотримання стандартів є основою нашої діяльності. Ми забезпечуємо довготривалість та позитивний вплив кожного проєкту.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "365px", lg: "337px" },
                                height: { xs: "250px", lg: "282px" },
                                background: { xs: palette.primary.dark, lg: palette.text.secondary },
                                borderRadius: "8px",
                                p: { xs: "7px 42px 7px 11px", lg: "7px 11px 11px 11px" },
                                mt: { xs: "14px", lg: "0px" },
                                display: { xs: "none", md: "block" }
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    loading="eager" src={(isMd || isXs) ? alert_outlined_white : alert_outlined} alt="alert_outlined" style={{ width: "40px", height: "40px", marginRight: "20px" }} />
                                <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: "#fff", lg: palette.background.default }}>
                                    Зростання і вдосконалення
                                </Typography>
                            </Box>
                            <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: "#fff", lg: palette.background.default }} sx={{ mt: { xs: "6px", lg: "20px" } }}>
                                Ми постійно навчаємося, розвиваємося та впроваджуємо інновації, щоб наші ініціативи залишалися актуальними та ефективними.
                                <br /><br />
                                Ми віримо, що зміни починаються з нас, тому постійно вдосконалюємося.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "365px", lg: "300px" },
                                height: { xs: "250px", lg: "282px" },
                                background: { xs: palette.text.secondary, lg: palette.primary.dark },
                                borderRadius: "8px",
                                p: { xs: "7px 39px 7px 11px", lg: "7px 11px 11px 11px" },
                                mt: { xs: "14px", lg: "0px" }
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    loading="eager" src={(isMd || isXs) ? heart_outlined : heart_outlined_white} alt="heart_outlined" style={{ width: "40px", height: "40px", marginRight: "20px" }} />
                                <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: palette.background.default, lg: "#fff" }}>
                                    Творчість і новаторство
                                </Typography>
                            </Box>
                            <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: palette.background.default, lg: "#fff" }} sx={{ mt: { xs: "6px", lg: "20px" } }}>
                                Ми генеруємо нові ідеї, впроваджуємо нестандартні рішення та шукаємо креативні підходи до вирішення проблем.
                                <br /><br />
                                Наша команда прагне створювати унікальні проєкти, які надихають і приносять користь суспільству.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "365px", lg: "337px" },
                                height: { xs: "250px", lg: "282px" },
                                background: { xs: palette.primary.dark, lg: palette.text.secondary },
                                borderRadius: "8px",
                                p: { xs: "7px 42px 7px 11px", lg: "7px 11px 11px 11px" },
                                mt: { xs: "14px", lg: "0px" },
                                display: { xs: "block", md: "none" }
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    loading="eager" src={(isMd || isXs) ? alert_outlined_white : alert_outlined} alt="alert_outlined" style={{ width: "40px", height: "40px", marginRight: "20px" }} />
                                <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: "#fff", lg: palette.background.default }}>
                                    Зростання і вдосконалення
                                </Typography>
                            </Box>
                            <Typography variant='h5' fontFamily="Fixel Display, sans-serif" color={{ xs: "#fff", lg: palette.background.default }} sx={{ mt: { xs: "6px", lg: "20px" } }}>
                                Ми постійно навчаємося, розвиваємося та впроваджуємо інновації, щоб наші ініціативи залишалися актуальними та ефективними.
                                <br />
                                Ми віримо, що зміни починаються з нас, тому постійно вдосконалюємося.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "107px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" sx={{ fontSize: { md: "h3.fontSize", lg: "h2.fontSize" } }}>
                        Наша команда
                    </Typography>
                    <Box sx={{ mt: { xs: "14px", lg: "30px" }, mx: { xs: "0px", lg: "33px" } }}>
                        <TeamCarousel />
                    </Box>
                </Grid>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Контакти */}
                <Contacts />
            </Grid >
        </>
    )
}

export default AboutUs